<template>
  <!-- dialog add docs -->
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'1000px'"
    :classDialog="'add-docs-dialog'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
    :appendToBody="true"
    :modalAppendToBody="true"
  >
    <template #body>
      <h3 class="dialogTitle">Tìm kiếm sổ</h3>
      <el-row :gutter="24" class="flex-row flex__left">
        <el-col :span="10" class="flex-row flex__left"></el-col>
        <el-col :span="14" class="flex-row">
          <i class="el-icon-search margin-right-10 clickable"></i>
          <el-input
            size="medium"
            placeholder="Nhập tên sổ/ghi chú yêu cầu để tìm kiếm"
            class="style-fullWidth input-border__radius__0 input-border__bottom"
            v-model="keyword"
            @keydown.enter.exact.native="search"
          />
        </el-col>
      </el-row>
      <div class="margin-bottom-10">
        <el-table
          ref="multipleTable"
          :data="listBookDocs"
          size="mini"
          stripe
          style="width: 100%"
          max-height="700"
          @selection-change="selectionsChanged"
        >
          <el-table-column width="40" type="index">
            <template #header>#</template>
          </el-table-column>
          <el-table-column
            label="Tên sổ"
            show-overflow-tooltip
            sortable
            property="bookDocSoDi"
          >
            <template slot-scope="scope">
              <span @click="itemClicked(scope.row)">{{
                  scope.row.bookDocSoDi
                }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Đơn vị đề nghị"
            width="200"
            show-overflow-tooltip
            sortable
            property="deptName"
          >
            <template slot-scope="scope">
              <span class="clickable" @click="itemClicked(scope.row)">{{
                  scope.row.deptName
                }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Ghi chú"
            width="250"
            show-overflow-tooltip
            property="bookDocNote"
          >
            <template slot-scope="scope">
              <span class="clickable" @click="itemClicked(scope.row)">{{
                  scope.row.bookDocNote
                }}</span>
            </template>
          </el-table-column>
          <el-table-column
            property="docDate"
            label="Dải số đã book / đã dùng"
            width="125"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span class="clickable" @click="itemClicked(scope.row)"
              >{{ getDaiSoDaBook(scope.row) }} /
                {{ getCurrentNumber(scope.row) }}</span
              >
            </template>
          </el-table-column>

          <el-table-column
            property="docDate"
            label="Ngày văn bản"
            width="125"
            sortable
          >
            <template slot-scope="scope">
              <div
                class="flex-row flex__left clickable"
                @click="itemClicked(scope.row)"
              >
                <p>
                  {{
                    scope.row.bookDocDate
                      | dateFormatter({dateFormat: "DD/MM/YYYY"})
                  }}
                </p>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          type="info"
          size="mini"
          class="btn__cancel btn-none__border"
          @click="cancel"
        >Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>

<script>
import dateFormatter from "../../../filters/dateFormatter";
import constants from "../../../constants";
import bookDocViewService from "../../../services/bookDocViewService";

export default {
  name: "dialog-add-book-number",
  props: ["isOpen"],
  filters: {dateFormatter},
  components: {
    dialogTemplate: () => import("../../common/custom-dialog.vue")
  },
  data() {
    return {
      docTypeVbDi: null,
      docTypeVbDen: null,
      docType: null,
      keyword: null,
      docs: null,
      selectedBookDocs: [],
      listBookDocs: []
    };
  },

  created() {
    this.docTypeVbDi = constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DI;
    this.docTypeVbDen = constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN;
    this.docType = constants.ADD_DOCS_DIALIG_DOC_TYPE.VB_DEN;

    this.search();
  },

  methods: {
    getCurrentNumber(bookDoc) {
      switch (bookDoc.bookDocStatus) {
        case constants.BOOKDOC.STATUS.DA_BOOK:
          return bookDoc.currentNumbers;
        default:
          return bookDoc.bookDocStatus;
      }
    },

    getDaiSoDaBook(bookDoc) {
      return [bookDoc.fromNumber, bookDoc.toNumber].join("-");
    },

    itemClicked(item) {
      this.$refs.multipleTable.toggleRowSelection(item);
    },

    submit() {
      this.$emit("submit", {
        bookDoc: this.selectedBookDocs[0],
        docType: this.docType
      });
    },

    cancel() {
      this.$emit("closeDialog");
    },

    selectionsChanged(val) {
      this.selectedBookDocs = val;
      this.submit();
    },

    search() {
      return bookDocViewService
        .findAllForBanHanh({query: this.keyword}, {sort: "bookDocSoDi,asc"})
        .then(response => (this.listBookDocs = response.data));
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/doc-out/components/dialog-add-book-number.vue